import { types } from 'mobx-state-tree';

export const Result = types.model('Result', {
  questionId: types.identifier,
  isCorrect: false,
  isIncorrect: false,
  isMissing: false,
});

export const ResultSummary = types.model('ResultSummary', {
  total: 0,
  correct: 0,
});
